import { supabase } from "@/integrations/supabase/client";
import type { Database } from "@/integrations/supabase/types";

export type Listing = Database["public"]["Tables"]["listings"]["Row"];
export type ListingInsert = Database["public"]["Tables"]["listings"]["Insert"];

export interface ListingFilters {
  neighborhood?: string;
  property_type?: string;
  bedrooms_min?: number;
  garage_min?: number;
  area_min?: number;
  area_max?: number;
  price_min?: number;
  price_max?: number;
  listing_code?: string;
  sort_by?: string;
}

export async function fetchListings(filters?: ListingFilters) {
  let query = supabase
    .from("listings")
    .select("*")
    .eq("is_active", true);

  // Sorting
  if (filters?.sort_by === "price_per_m2_asc") {
    query = query.order("price_per_m2", { ascending: true, nullsFirst: false });
  } else {
    query = query
      .order("is_featured", { ascending: false })
      .order("created_at", { ascending: false });
  }

  if (filters?.neighborhood) query = query.eq("neighborhood", filters.neighborhood);
  if (filters?.property_type) query = query.eq("property_type", filters.property_type as any);
  if (filters?.bedrooms_min) query = query.gte("bedrooms", filters.bedrooms_min);
  if (filters?.garage_min) query = query.gte("garage_spots", filters.garage_min);
  if (filters?.area_min) query = query.gte("area_m2", filters.area_min);
  if (filters?.area_max) query = query.lte("area_m2", filters.area_max);
  if (filters?.price_min) query = query.gte("price", filters.price_min);
  if (filters?.price_max) query = query.lte("price", filters.price_max);
  if (filters?.listing_code) query = query.ilike("listing_code", `%${filters.listing_code}%`);

  const { data, error } = await query;
  if (error) throw error;
  return data as Listing[];
}

export async function fetchListingById(id: string) {
  const { data, error } = await supabase
    .from("listings")
    .select("*")
    .eq("id", id)
    .single();
  if (error) throw error;
  return data as Listing;
}

export async function fetchListingBySlug(slug: string) {
  const { data, error } = await supabase
    .from("listings")
    .select("*")
    .eq("slug", slug)
    .eq("is_active", true)
    .single();
  if (error) throw error;
  return data as Listing;
}
